// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-scroll';
// Component
import HeaderPhones from '../HeaderPhones/HeaderPhones';
import CustomScrollLink from '../../CustomScrollLink/CustomScrollLink';
// Styles
import * as styles from './CompanyInfoBlock.scss';

const CompanyInfoBlock = (props) => {
  const handleClick = evt => evt.stopPropagation();

  return (
    // eslint-disable-next-line max-len
    <CustomScrollLink offset={props.offset || (props.isMobile ? -90 : -95)} to={props.scrollToBlock} spy activeClass={styles.activeBlock} className={styles.companyInfoBlock}>
      <div onClick={handleClick} className={styles.container}>
        {!props.isMobile && <div className={styles.title}>{props.title}</div>}
        <div className={styles.infoWr}>
          <HeaderPhones
            translate={props.translate}
            phoneNumber={props.phoneNumber}
            locale={props.locale}
            className="topBlock"
            isMobile={props.isMobile}
            isIconFill
          />
          {(!props.isMobile && !props.isShowMoreInfo) && <span className={styles.or}>{props.translate('or')}</span>}
          {(!props.isMobile && !props.isShowMoreInfo) && <Link offset={-145} to="contacts-form-block" className={styles.anchor} smooth>{props.translate('forMoreInfo')}</Link>}
        </div>
      </div>
    </CustomScrollLink>
  );
};

CompanyInfoBlock.propTypes = {
  title: PropTypes.string,
  isShowPhone: PropTypes.bool,
  onShowPhones: PropTypes.func,
  translate: PropTypes.func,
  isMobile: PropTypes.bool,
  locale: PropTypes.string,
  offset: PropTypes.number,
  isShowMoreInfo: PropTypes.bool,
  scrollToBlock: PropTypes.string,
  phoneNumber: PropTypes.string
};

export default CompanyInfoBlock;
